import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popup", {show: _ctx.showPopup}]),
    ref: "modalInfo"
  }, [
    (_ctx.showPopup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["popup-content", {show: _ctx.showPopup}]),
          ref: "modalInfoContent"
        }, [
          _renderSlot(_ctx.$slots, "default"),
          _createElementVNode("span", {
            class: "popup-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
          }, _hoisted_2)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}